export default class ThemeManager {
    
    // Uruchamia się przy starcie strony
    static init() {
    const savedTheme = localStorage.getItem('theme');
    const theme = savedTheme || 'light';

    document.documentElement.dataset.theme = theme;

    if (!savedTheme) {
        localStorage.setItem('theme', theme);
    }
	}

    static set(theme) {
        document.documentElement.dataset.theme = theme;
        localStorage.setItem('theme', theme);
    }

    static toggle() {
        // Przełącza na przeciwny motyw
        this.set(
            document.documentElement.dataset.theme === 'light'
                ? 'dark'
                : 'light'
        );
    }

    static get() {
        return document.documentElement.dataset.theme || 'light';
    }
}
